<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" :width="dialogwidth">
    <el-form :model="FormData" :rules="FormRules" ref="dialogForm" >
      <el-form-item
        v-for="(item, index) in renderList"
        :key="index"
        :prop="item.name"
       >
        <el-input v-model="FormData[item.name]"
                  :placeholder="item.placeholder"
                  :type="item.type"
                  v-if="item.type==='input'|| item.type==='password'"
        ></el-input>
        <el-select
          v-model="FormData[item.name]"
          :placeholder="item.placeholder"
          style="display: block"
          v-if="item.type==='select'"
        >
          <el-option
            v-for="itm in item.options"
            :key="itm.value"
            :label="itm.label"
            :value="itm.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="validateData()">确 定</el-button>
    </div>
  </el-dialog>

</template>

<script>
  import {
    extend,
    findIndex,
    forEach
  } from 'lodash';
  import Vue from 'vue';
  export default{
    // 是否有说明文字
    // 表单类型：输入框 下拉框 选择框
    // 表单名字（name）
    // 验证规则
    // 事件名： @validateForm
    // placeholder
    props: {
      title: {
        type: String,
        required: true,
      },
      form: {
        required: true,
        type: Object
      },
      rules: Object,
      renderList: {
        required: true,
        type: Array,
      },
      formLabelWidth: {
        default: '120px'
      },
      dialogwidth: {
        type: String,
        default: '400px'
      }
    },
    data(){
      return {
        dialogVisible: false,
        FormData: {}
      }
    },
    watch: {
      dialogVisible(val){
        if(val === false){
          this.$parent.clearData();
        }
      },

      form(val){
        this.FormData = extend({}, val);
      }
    },
    computed: {
      FormRules(){
        let rules = extend({}, this.rules);
        let index = findIndex(this.renderList, {type: 'password'});
        if(index !== -1){
          if(this.form.hasOwnProperty('password') && this.form.hasOwnProperty('password_confirmation')){
            rules.password_confirmation = [
              {validator: (rule, value, callback)=>{
                if (value === '') {
                  callback(new Error('请再次输入密码'));
                } else if (value !== this.FormData.password) {
                  callback(new Error('两次输入密码不一致'))
                }
                callback()
              }, trigger: 'blur'}
            ]
          }else {
            console.error('密码需要传入指定字段名!');
          }
        }

        return rules;
      }
    },

    methods: {
      open(){
        this.dialogVisible = true;
      },

      validateData(){
        this.$refs.dialogForm.validate(valid => {
          if (valid) {
            this.$emit('commit', this.FormData);
            this.dialogVisible = false;
          }
        })
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/views/Component/FormRender/index.vue?62dbf359